import { z } from "zod";

const CreateBookingExtraSchema = z.object({
    booking_room_id: z.string().uuid("Invalid booking room ID"),
    item_name: z.string().min(1, "Item name is required"),
    qty: z.number().min(1, "Quantity must be at least 1"),
    amount: z.number().min(0, "Amount must be 0 or greater"),
    date: z.string().min(1, "Date is required"),
});

export { CreateBookingExtraSchema };
export type CreateBookingExtraFormData = z.infer<typeof CreateBookingExtraSchema>;
